import React, { useEffect } from 'react';
import DetailStyled from './DetailStyled';
// import { ArchiveRounded } from '@material-ui/icons';
import { Box } from '@material-ui/core';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { fmtThousand, fmtPercent } from '@/utils/comUtil';
import { useDispatch, useSelector } from 'dva';
import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
// import { download } from '@/utils/downloadUtil';
import dayjs from 'dayjs';
// const TOTAL = {
//   SELL_ACCOUNT: '销售金额',
//   SELL_AMOUNT: '销售单数',
//   SELL_NUM: '销售张数',
//   PER_TICKET: '客单价',
//   PER_TICKET_NUM: '客单件',
//   RECEIVED_NUM: '领取张数',
//   WRITE_OFF_NUM: '核销张数',
//   WRITE_OFF_AMOUNT: '核销金额',
//   WRITE_OFF_PERCENT: '核销率',
//   USE_TICKET_ORDER: '用券订单',
// };

const getSaleData = (arr, type) => {
  return (arr || []).find((item) => item.LABEL === type)?.VALUE || NaN;
};
const Detail = (props) => {
  // const downloadRef = useRef();
  const {
    name = null,
    dateBegin = null,
    dateEnd = null,
    code = null,
  } = props || {};
  const dispatch = useDispatch();
  //下载明细数据
  // const exportActivityDetail = () => {
  //   download('/activityReport/exportActivityDetail', { code }, '活动分析');
  // };
  //查询活动详情
  useEffect(() => {
    dispatch({
      type: 'analyse/activityDetail',
      payload: {
        values: {
          code,
        },
      },
    });
  }, [code, dispatch]);
  //活动数据基准时间
  useEffect(() => {
    dispatch({
      type: 'analyse/deadLineTime',
      payload: {
        values: {
          code,
        },
      },
    });
  }, [code, dispatch]);
  const { activityDetail, deadLineTime } = useSelector(
    (state) => state.analyse,
  );
  const { date } = deadLineTime || {};
  //活动概要数据详情
  const ACTIVITY_SUMMARY = activityDetail?.filter((item) => {
    return item.index === 'ACTIVITY_SUMMARY';
  });
  const ACTIVITY_SUMMARY_DATA = sinTimeDimensionSinIndexMulValue(
    ACTIVITY_SUMMARY || [],
  );
  //销售汇总数据详情
  const SALES_SUMMARY = activityDetail?.filter((item) => {
    return item.index === 'SALES_SUMMARY';
  });
  const SALES_SUMMARY_DATA = sinTimeDimensionSinIndexMulValue(
    SALES_SUMMARY || [],
  );
  const COUPON_SUMMARY = activityDetail?.filter((item) => {
    return item.index === 'COUPON_SUMMARY';
  });
  const COUPON_SUMMARY_DATA = sinTimeDimensionSinIndexMulValue(
    COUPON_SUMMARY || [],
  );

  return (
    <DetailStyled>
      <Box
        data-log={JSON.stringify({
          oid: 'page_marketing_activity_miniprogram_management_activity_analysis',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="main_contain"
      >
        <Box className="deadLine">
          <CalendarTodayIcon />
          数据基准日期:{dayjs(date).format('YYYY / MM / DD')}
        </Box>
        <Box className="main_name">
          <div className="main_name_left">
            <p className="name">{name}</p>
            <p className="time">
              <span>活动时间: </span>
              <span>
                {dayjs(dateBegin).format('YYYY-MM-DD')} ~{' '}
                {dayjs(dateEnd).format('YYYY-MM-DD')}
              </span>
            </p>
          </div>
          <div className="main_name_right">
            {/* <Button
              data-log={JSON.stringify({
                oid: 'link_marketing_activity_miniprogram_management_activity_analysis_download_detail_data',
                events: ['_ev', '_ec'],
                params: {
                  code,
                },
              })}
              ref={downloadRef}
              variant="contained"
              color="primary"
              size="small"
              sx={{
                width: '134px',
                height: '34px',
                fontSize: '13px',
                borderRadius: '24px',
              }}
              startIcon={<ArchiveRounded />}
              onClick={exportActivityDetail}
            >
              <span className="downloadDetail">下载明细数据</span>
            </Button> */}
          </div>
        </Box>
        <Box className="main_activity">
          <div className="activity_left">
            <p className="name activity">
              <SvgIconML name="Group" size={24}></SvgIconML>
              <span className="text">活动概要</span>
            </p>
            <p className="subTitle">
              访问人数
              <span>
                {fmtThousand(
                  getSaleData(ACTIVITY_SUMMARY_DATA, 'PARTICIPANTS_NUM'),
                )}
              </span>
            </p>
            <p className="subRegiter">
              注册人数
              <span className="num">
                {fmtThousand(
                  getSaleData(ACTIVITY_SUMMARY_DATA, 'REGISTERED_NUM'),
                )}
              </span>
              <span style={{ color: '#616161' }}>
                {fmtPercent(
                  getSaleData(ACTIVITY_SUMMARY_DATA, 'ENROLLMENT_RATE'),
                  2,
                )}
              </span>
            </p>
            <p className="subRegiter">
              购买人数
              <span className="num">
                {fmtThousand(
                  getSaleData(ACTIVITY_SUMMARY_DATA, 'PURCHASERS_NUM'),
                )}
              </span>
              <span style={{ color: '#616161' }}>
                {fmtPercent(
                  getSaleData(ACTIVITY_SUMMARY_DATA, 'PURCHASER_RATE'),
                  2,
                )}
              </span>
            </p>
          </div>
          <div className="activity_center">
            <p className="name activity">
              <SvgIconML name="sell" size={24}></SvgIconML>
              <span className="text">销售汇总</span>
            </p>
            <p className="subTitle">
              销售金额
              <span>
                {fmtThousand(getSaleData(SALES_SUMMARY_DATA, 'SALES_AMOUNT'))}
              </span>
            </p>
            <p className="subRegiter">
              销售单数
              <span className="num number">
                {fmtThousand(getSaleData(SALES_SUMMARY_DATA, 'SALES_ORDER'))}
              </span>
              <span>
                客单价
                <span className="num">
                  {fmtThousand(
                    getSaleData(SALES_SUMMARY_DATA, 'MEMBER_AMOUNT'),
                  )}
                </span>
              </span>
            </p>
            <p className="subRegiter">
              销售张数
              <span className="num number">
                {fmtThousand(getSaleData(SALES_SUMMARY_DATA, 'SALES_NUM'))}
              </span>
              <span>
                客单件
                <span className="num">
                  {fmtThousand(getSaleData(SALES_SUMMARY_DATA, 'MEMBER_PRICE'))}
                </span>
              </span>
            </p>
          </div>
          <div className="activity_right">
            <p className="name activity">
              <SvgIconML name="couponTotal" size={24}></SvgIconML>
              <span className="text">优惠券汇总</span>
            </p>
            <p className="subTitle">
              领取张数
              <span>
                {fmtThousand(getSaleData(COUPON_SUMMARY_DATA, 'RECEIVE_COUNT'))}
              </span>
            </p>
            <p className="subRegiter">
              核销张数
              <span className="num number">
                {fmtThousand(getSaleData(COUPON_SUMMARY_DATA, 'CONSUME_COUNT'))}
              </span>
              <span>
                核销率
                <span className="num">
                  {fmtPercent(getSaleData(COUPON_SUMMARY_DATA, 'CONSUME_RATE'))}
                </span>
              </span>
            </p>
            <p className="subRegiter">
              核销金额
              <span className="num number">
                {fmtThousand(
                  getSaleData(COUPON_SUMMARY_DATA, 'CONSUME_AMOUNT'),
                )}
              </span>
              <span>
                用券订单
                <span className="num">
                  {fmtThousand(getSaleData(COUPON_SUMMARY_DATA, 'ORDER_COUNT'))}
                </span>
              </span>
            </p>
          </div>
        </Box>
      </Box>
    </DetailStyled>
  );
};
export default Detail;
